if (!customElements.get('cdda-toggle')) {
  class CddaToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('cdda-popup:toggle'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('cdda-toggle', CddaToggle);
}
